<template>
    <div class="modal fade" id="pg-bundle-modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"  aria-hidden="true" data-keyboard="false" data-backdrop="static" style="overflow-y: auto;z-index: 1400;">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-black font-normal" id="exampleModalLongTitle">Add Bundle</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closePGBundleModal">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body bg-white">
                    <div class="mt-2">
                        <label class="text-black">Name<span class="text-danger">*</span></label>
                        <input class="form-control" type="text" placeholder="Name" v-model="pgProductServicesBundleForm.name"
                               :class="[({'border-red' : pgProductServicesBundleForm.errors ? pgProductServicesBundleForm.errors.has('name') : ''})]"
                               @input="resetValidation('name')">
                        <div class="text-red text-xs" v-if="pgProductServicesBundleForm.errors && pgProductServicesBundleForm.errors.has('name')">{{
                                pgProductServicesBundleForm.errors ? pgProductServicesBundleForm.errors.get('name') : ''}}
                        </div>
                    </div>
                    <div class="mt-2">
                        <label class="text-black">Description</label>
                        <textarea class="form-control" v-model="pgProductServicesBundleForm.description"
                                  placeholder="Description"
                                  :class="[({'border-red' : pgProductServicesBundleForm.errors ? pgProductServicesBundleForm.errors.has('description') : ''})]"
                                  @input="resetValidation('description')">
                            </textarea>
                        <div class="text-red text-xs" v-if="pgProductServicesBundleForm.errors && pgProductServicesBundleForm.errors.has('description')">
                            {{pgProductServicesBundleForm.errors ? pgProductServicesBundleForm.errors.get('description') : ''}}
                        </div>
                    </div>
                    <div class="mt-3 d-flex justify-content-between">
                        <small class="text-dark">Products/Services included in the Bundle:</small>
                        <span class="pointer underline" @click="openPGProductServicesModal">
                            <i class="fa fa-plus px-1" aria-hidden="true"></i>
                            Add Product/Services
                        </span>
                    </div>
                    <pg-product-and-services-bundle-table ref="ProductServicesBundle" :allPGProductServices="allPGProductServices"></pg-product-and-services-bundle-table>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" @click="savePGProductServiceBundle">
                        <i v-if="pgProductServicesBundleFormLoader" class="fa fa-spinner fa-spin text-white"></i>
                        Save
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PgProductAndServicesBundleTable from "../pg-product-and-services-bundle-table.vue";
import Form from "../../../../../utils/form";

export default {
    name: 'pg-bundle-modal',
    props: ['allPGProductServices', 'editProductServicesData', 'editProductServicesType'],
    components: {PgProductAndServicesBundleTable},
    data() {
        return {
            pgProductServicesBundleForm: new Form({
                id: null,
                name: null,
                description: null,
                productServices: []
            }),
            pgProductServicesBundleFormLoader: false,
        }
    },
    watch: {
        editProductServicesData: {
            handler(val) {
                if(val !== null && val !== undefined && val.bundle_id) {
                    if(this.editProductServicesType === 'edit') {
                        this.pgProductServicesBundleForm.id = val.bundle_id;
                    }
                    this.pgProductServicesBundleForm.name = val.bundle_name;
                    this.pgProductServicesBundleForm.description = val.description;
                    if(val.bundle_product_services.length > 0) {
                        this.$refs.ProductServicesBundle.bundle = val.bundle_product_services;
                    }
                    else {
                        this.$refs.ProductServicesBundle.resetProductServicesBundle();
                    }
                }
            },
            immediate: true
        }
    },
    methods: {
        open() {
            $('#pg-bundle-modal').modal('show');
        },
        openPGProductServicesModal() {
            Bus.$emit('open-pg-product-services-modal');
        },
        closePGBundleModal() {
            $('#pg-bundle-modal').modal('hide');
            this.pgProductServicesBundleForm.hardReset();
            this.$refs.ProductServicesBundle.resetProductServicesBundle();
            Bus.$emit('product-services-bundle-modal-closed');
        },
        savePGProductServiceBundle() {
            let self = this;
            self.pgProductServicesBundleFormLoader = true;
            self.pgProductServicesBundleForm.productServices = self.$refs.ProductServicesBundle.bundle;
            self.pgProductServicesBundleForm.post(route('api.proposal-settings.product-services.store-product-services-bundle')).then((data) => {
                self.pgProductServicesBundleFormLoader = false;
                self.closePGBundleModal();
                self.pgProductServicesBundleForm.hardReset();
                self.$refs.ProductServicesBundle.resetProductServicesBundle();
                Bus.$emit('get-all-pg-product-services');
            }).catch((error) => {
                self.pgProductServicesBundleFormLoader = false;
            });
        },
        resetValidation(field) {
            delete this.pgProductServicesBundleForm.errors.errors[field];
        }
    }
}
</script>
